import React from 'react'
import { useApp } from '../../context/AppContext'
import { Icon, useT } from '../../shared'
import { Card, Btn } from '../../shared/components'
import { getNav } from '../../App'

// Subset nav admin yang sudah ada, bukan daftar fitur baru. Tidak ada badge
// "BARU" untuk v1 (dikonfirmasi user). Dulu dipecah jadi dua kartu ("Tautan
// Cepat" dan "Aplikasi") yang memuat Reports/Certificates/Analytics dua kali;
// sekarang satu daftar, urutannya mengikuti sidebar.
const APP_IDS = [
  'enrollment', 'users', 'progress', 'reports', 'doc-library',
  'penilaian', 'certificates', 'ai', 'settings',
]

// "Kelola Trainer" bukan navigasi `page` — satu-satunya jalur assign/unassign
// trainer ke program (ManageTrainersModal) sebelumnya cuma bisa dibuka dari
// program-grid lama di AdminDashboard, yang sekarang dihapus. `onManageTrainers`
// dipanggil oleh AdminDashboardHome yang memegang state modal + program aktif.
export function ApplicationsPanel({ onManageTrainers }) {
  const { lang, navigate } = useApp()
  const t = useT()
  const items = getNav('admin', t, lang).filter((i) => !i.section && APP_IDS.includes(i.id))

  return (
    <Card title={lang === 'id' ? 'Aplikasi' : 'Applications'}>
      <div className="col gap-1">
        {items.map((item) => (
          <Btn
            key={item.id}
            variant="ghost"
            block
            style={{ justifyContent: 'flex-start', height: 34, padding: '0 6px' }}
            icon={<Icon name={item.icon} size={14} />}
            onClick={() => navigate(item.id)}
          >
            <span style={{ flex: 1, textAlign: 'left', fontSize: 13 }}>{item.label}</span>
            <Icon name="chevron_right" size={12} color="var(--text-4)" />
          </Btn>
        ))}
        <Btn
          variant="ghost"
          block
          style={{ justifyContent: 'flex-start', height: 34, padding: '0 6px' }}
          icon={<Icon name="users" size={14} />}
          onClick={onManageTrainers}
        >
          <span style={{ flex: 1, textAlign: 'left', fontSize: 13 }}>
            {lang === 'id' ? 'Kelola Trainer' : 'Manage Trainers'}
          </span>
          <Icon name="chevron_right" size={12} color="var(--text-4)" />
        </Btn>
      </div>
    </Card>
  )
}
